import React from "react";
import { Helmet } from "react-helmet";
import HeroSlider from "../components/HeroSlider";
import { useTranslation } from "react-i18next";

const Pardon = () => {
  const {t} = useTranslation();
  return (
    <>
      <div className="home-page">
        <Helmet>
          <title>
            Pardon | Min & Ying Legal Services Professional Corporation
          </title>
          
          <meta
            name="description"
            content="Pardon | Min & Ying Legal Services Professional Corporation"
          />
        </Helmet>
        <HeroSlider/>
        {/* HERO=========== */}
        {/* <div className="container-fluid">
          <div className="row">
            <div className="hero-section">
              <div className="hero-overlay"></div>
              <div className="text-container d-flex flex-column justify-content-start align-items-start pt-6 slide">
                <div className="text-1 fs-2 pb-3 text-red-200">Min & Ying Legal Services Professional Corporation Professional Corporation222</div>
                <div className="text-2 fs-4">
                  BIROU DE AVOCAT SI INSOLVENTA
                  <span className="fw-bold">
                    <br></br> Bucuresti{" "}
                  </span>
                </div>
                <div className="text-3 fst-italic fw-light">
                  "Nu este o adevărată justiție acolo unde nu există dreptate,
                  iar dreptatea nu poate fi găsită acolo unde nu există adevăr."
                  - <span>Lucius Annaeus Seneca.</span>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/*TE CONFRUNTI CU O PROBLEMA========= */}

        <section className="card py-5 px-3 border-0 container">
          <div className="row">
            <div className="col-lg-7">
              <div className="card-body">
                <h6 className="guide-text mb-4">{t('pardon.title')}</h6>
                <p className="fw-normal">
                  {t('pardon.intro')}
                </p>
                <p>{t('pardon.weGuide')}</p>
                <ol style={{paddingLeft: '1.5rem'}}>
                  <li>{t('pardon.service1')}</li>
                  <li>{t('pardon.service2')}</li>
                  <li>{t('pardon.service3')}</li>
                  <li>{t('pardon.service4')}</li>
                  <li>{t('pardon.service5')}</li>
                  <li>{t('pardon.service6')}</li>
                </ol>
                <p>{t('pardon.summary')}</p>
              </div>
            </div>

            <div className="col-lg-5 d-flex align-items-center justify-content-center">
              <div>
                <img
                  src="/assets/services/pardon.webp"
                  className="intro-img img-fluid d-block rounded-2"
                  alt=" a gavel, scales of justice, and law books"
                  style={{ maxHeight: "300px" }}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Pardon;